import { Box, Center, Divider, Flex, Img, Stack, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import img from "../../Assets/Images/AbdrRehman.jpg";
import img1 from "../../Assets/Images/Nouman.jpg";

function SalesTeam() {
  const textStyle = {
    color: "#1F508B",
    fontSize: "18px",
    fontWeight: "300",
    lineHeight: "1.5rem"
  };
  const headingStyle = {
    color: "#1F508B",
    fontSize: "30px",
    fontWeight: "300",
    lineHeight: "1.5rem"
  };
  return (
    <>
      <Center>
        <Stack maxW={"1010px"} width={"100%"} alignItems={"center"} mt={"60px"}>
          <Box w={"80%"}>
            <Center>
              <Box flexDirection={"column"} mt={"50px"}>
                <Text {...headingStyle}>Sales Team</Text>
                <Divider alignItems={"center"} mt={"30px"} mb={"60px"} borderColor={"#1F508B"} />
              </Box>
            </Center>
            <Flex spacing={8} mb={"50px"} align="space-between" justifyContent={{ base: "center", md: "space-between" }} flexWrap={"wrap"}>
              <VStack>
                <Img
                  boxShadow={"lg"}
                  borderRadius="full"
                  boxSize="180px"
                  alt="ceo"
                  border={"12px solid white"}
                  src={img}
                  _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }} />
                <Text {...textStyle} mt={"20px"}>
                  Abdur Rehman
                </Text>
                <Text {...textStyle} mt={"1px"}>
                  CRE Sales Agent
                </Text>
              </VStack>
              <VStack>
                <Img
                  boxShadow={"lg"}
                  borderRadius="full"
                  boxSize="180px"
                  alt="ceo"
                  border={"12px solid white"}
                  src={img1}
                  _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }} />
                <Text {...textStyle} mt={"20px"}>
                  Nouman Nadeem
                </Text>
                <Text {...textStyle} mt={"1px"}>
                  On-Chain Sales
                </Text>
              </VStack>
            </Flex>
          </Box>
        </Stack>
      </Center>
      <Divider mb={"20px"} mt={"80px"} />
    </>
  )
}

export default SalesTeam